import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';
import { APROBADO, REGISTRADO, ANULADO, RECHAZADO, IMPORTADO } from '../../../common/types/requerimientoEstadoType';

export default function ResultList(props) {
    const renderColor = (row) => {
        if (row.idRequerimientoEstado === REGISTRADO)
            return 'blue';
        if (row.idRequerimientoEstado === APROBADO)
            return 'green';
        if (row.idRequerimientoEstado === IMPORTADO)
            return 'gold';
        if (row.idRequerimientoEstado === RECHAZADO)
            return 'orange';
        if (row.idRequerimientoEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onVer(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Editar">
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onEditar(row)}
                                    disabled={row.idRequerimientoEstado !== REGISTRADO ? true : false}
                                />
                            </Tooltip>
                            
                            <Tooltip placement="top" title="Anular">
                                <Button
                                    type="danger"
                                    icon="delete"
                                    size={"small"}
                                    onClick={() => props.onAnular(row)}
                                    disabled={row.idRequerimientoEstado !== REGISTRADO ? true : false}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Imprimir">
                                <Button
                                    type="primary"
                                    icon="printer"
                                    size={"small"}
                                    onClick={() => props.onImprimir(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Número Documento',
                    dataIndex: 'numeroDocumento',
                    key: 'numeroDocumento',
                    sorter: true
                },
                
                {
                    title: 'Entidad',
                    dataIndex: 'razonSocial',
                    key: 'razonSocial',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                //{
                //    title: 'Tipo Documento',
                //    dataIndex: 'tipoDocumentoCliente',
                //    key: 'tipoDocumentoCliente',
                //    sorter: true
                //},
          
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreRequerimientoEstado',
                    key: 'nombreRequerimientoEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );

}

